import React from 'react';
import { Container, Row, Col } from 'ds/components/grid-system';
import { useLocale } from 'locale';
import { ShowAt } from 'consts/breakpoints';
import { makePlaceholdersArray } from 'utils/placeholders';
import { CardsSkeleton } from 'components/cards/listing/CardsSkeleton';
import { LastContactSectionContainer, SmallCardPlaceholderMain, ShortlistHeader } from './styled';
import { CardsCarousel } from 'ds/components/carousels/cards-carousel/CardsCarousel';
import { SubsectionHeader } from 'components/feed-sections-utility';

const SmallCardPlaceholder = () => (
  <>
    <ShowAt to={2}>
      <SmallCardPlaceholderMain>
        <div />
        <div>
          <div />
          <div />
        </div>
      </SmallCardPlaceholderMain>
      <div />
    </ShowAt>
    <ShowAt from={3}>
      <Col from3={4} from5={3}>
        <SmallCardPlaceholderMain>
          <div />
          <div>
            <div />
            <div />
          </div>
        </SmallCardPlaceholderMain>
        <div />
      </Col>
    </ShowAt>
  </>
);

const LastContactListSkeleton: React.FC = () => (
  <Row>
    <ShowAt to={2}>
      <CardsCarousel>
        {makePlaceholdersArray(3, <SmallCardPlaceholder/>)}
      </CardsCarousel>
    </ShowAt>
    <ShowAt from={3} to={4}>
      {makePlaceholdersArray(3, <SmallCardPlaceholder/>)}
    </ShowAt>
    <ShowAt at={5}>
      {makePlaceholdersArray(4, <SmallCardPlaceholder/>)}
    </ShowAt>
  </Row>
);

export const ShortlistPageSkeleton: React.FC = () => {
  const { t } = useLocale();

  return (
    <>
      <LastContactSectionContainer>
        <Container>
          <Row>
            <Col>
              <SubsectionHeader weight="medium">{t('shortlist.lastContact.label')}</SubsectionHeader>
            </Col>
          </Row>
          <LastContactListSkeleton />
        </Container>
      </LastContactSectionContainer>

      <Container>
        <Row>
          <Col>
            <ShortlistHeader data-auto={`savedListing-block-title`} children={t('shortlist.savedListing.label')} />
          </Col>
        </Row>
        <CardsSkeleton />
      </Container>
    </>
  );
};
